import {
    getMeteringRecord,
    listMeteringRecords
} from './queries';
import {
    createMeteringRecord,
    deleteMeteringRecord,
    updateMeteringRecord,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {MeteringRecord} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


export type ListMeteringRecords = {
    listMeteringRecords: { items: MeteringRecord[], nextToken: string }
}

export type GetMeteringRecord = {
    getMeteringRecord: MeteringRecord
}

export type CreateMeteringRecord = {
    createMeteringRecord: MeteringRecord
}

export type UpdateMeteringRecord = {
    updateMeteringRecord: MeteringRecord
}

export type DeleteMeteringRecord = {
    deleteMeteringRecord: string
}


const client = billingApiClient;


export const fetchRecords = async (query: ListRecordsQuery) => {
    const response = await client.graphql<GraphQLQuery<ListMeteringRecords>>({
                                                                                 query: listMeteringRecords,
                                                                                 variables: {
                                                                                     ...query
                                                                                 },
                                                                             });
    return {
        items: response.data?.listMeteringRecords.items,
        nextToken: response.data?.listMeteringRecords.nextToken
    }
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetMeteringRecord>>({
                                                                               query: getMeteringRecord,
                                                                               variables: {id: id},
                                                                           });
    return response.data?.getMeteringRecord;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateMeteringRecord>>({
                                                                                  query: createMeteringRecord,
                                                                                  variables: {input: payload},
                                                                              });
    console.debug('in the service response', response);
    return response.data?.createMeteringRecord;
};

export const update = async (id: string, record: MeteringRecord) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;

    const response = await client.graphql<GraphQLQuery<UpdateMeteringRecord>>({
                                                                                  query: (updateMeteringRecord),
                                                                                  variables: {input: record},
                                                                              });
    return response.data?.updateMeteringRecord;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteMeteringRecord>>({
                                                                                  query: (deleteMeteringRecord),
                                                                                  variables: {input: {id: id}},

                                                                              });
    return response.data?.deleteMeteringRecord;
};
